import { dividerCost, specialCost, SPECIAL_TIMERS } from './economy.js';
import type { StationData, TerminalEconomyData } from './types.js';

export const EQUIPMENT = {
    boots: { name: 'Running shoes', field: 'boots', effect: 'Walk faster around the terminal.' },
    bags: { name: 'Baggage capacity', field: 'bagLevel', effect: 'Carry two more bags per level.' },
    cleaning: { name: 'Cleanup capacity', field: 'trashLevel', effect: 'Carry two more pieces of litter per level.' },
    shuttle: { name: 'Arrival shuttle', field: 'arrivalLevel', effect: 'Shorter intervals between passengers, while aircraft have empty seats.' },
    chairs: { name: 'Waiting chairs', field: 'chairLevel', effect: 'Adds waiting seats. Each level raises paid lounge income by 4%.' },
} as const;
export type EquipmentKind = keyof typeof EQUIPMENT | 'divider';
export function equipmentQuote(e: TerminalEconomyData, ss: StationData[], kind: EquipmentKind, stage: number) {
    if (kind === 'divider') {
        const s = ss[stage];
        if (!s?.unlocked) return null;
        return { name: stage === 6 ? 'Boarding line' : 'Queue ropes', effect: stage === 6 ? 'Improves boarding service efficiency by 5% per level. Passengers use one line and one bollard.' : 'Adds a rope lane up to four lanes, and improves service efficiency by 5% per level.', level: s.dividerLevel, cost: dividerCost(s, e), until: s.dividerUntil };
    }
    const item = EQUIPMENT[kind];
    if (!item) return null;
    return { name: item.name, effect: item.effect, level: e[item.field], cost: specialCost(kind, e), until: e[SPECIAL_TIMERS[kind]] };
}
